import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import * as ace from 'ace-builds';

import { AppComponent } from './app.component';
import { ControlComponent } from './control/control.component';
import { GoogleAdsenseComponent } from './google-adsense/google-adsense.component';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ApiService } from './api.service';

@NgModule({
  declarations: [
    AppComponent,
    ControlComponent,
    GoogleAdsenseComponent,
    EditComponent,
    ViewComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    BrowserAnimationsModule,
    HttpClientModule,
  ],
  providers: [ ApiService ],
  bootstrap: [ AppComponent ],
})
export class AppModule { }
